import type { SignOptions } from 'jsonwebtoken';
import { z } from 'zod';

export type DoorDashAPIBody = {
    dropoff_address: {
        street: string;
        unit: string;
        city: string;
        state: string;
        zip_code: string;
    };
    pickup_address?: {
        street: string;
        unit: string;
        city: string;
        state: string;
        zip_code: string;
    };
    external_store_id?: string;
    order_value: number;
    pickup_time: string;
    productId: string;
};

export type DoorDashAPIResponseEstimate = {
    success: boolean;
    raw: {
        id: number;
        fee: number;
        currency: string;
        pickup_time: string;
        delivery_time: string;
        pickup_window_start_time: string | null;
        pickup_window_end_time: string | null;
        dropoff_address: {
            city: string;
            state: string;
            street: string;
            unit: string;
            zip_code: string;
            dasher_parking_details: string | null;
            full_address: string;
        };
        fee_breakdown: string | null;
        fee_components: string | null;
        tax: number;
        tax_components: string | null;
    };
    api: {
        pickupAddress: {
            street: string;
            unit: string | null;
            city: string;
            state: string;
            zip_code: string;
        };
        pickupStoreId: string;
        pickupStoreInventoryListId: string;
        pickupStoreInventoryQuantity: number;
        messages: string[];
    };
};

export type CustomSignOptions = SignOptions & {
    iat: number;
    exp: number;
    iss: string;
    kid: string;
    aud: string;
};

export const ResultEstimateAPISchema = z.union([
    z.object({
        success: z.literal(true),
        storeId: z.number(),
    }),
    z.object({
        success: z.literal(false),
    }),
]);

export type ResultEstimateAPI = z.infer<typeof ResultEstimateAPISchema>;

export type DoorDashAPIResponseValidation = DoorDashAPIResponseEstimate;
